import { request } from '../utils/axios'

/* 登录 */
export function getCover() {
  return request({
    url: '/api/Login/Banner',
    method: 'get'
  })
}

export function getVideoDetail(params) {
  return request({
    url: '/api/Courseware/VideoInfo',
    method: 'get',
    params
  })
}

export function setFootmarl(data) {
  return request({
    url: '/api/Main/addFootmark',
    method: 'post',
    data
  })
}

export function validPasswordApi(data) {
  return request({
    url: '/api/Personal/CheckPwd',
    method: 'post',
    data
  })
}

// 志愿服务板块-个人信息-修改 检查旧密码
export function validPasswordSocialApi(data) {
  return request({
    url: 'api/Login/CheckPwds',
    method: 'post',
    data
  })
}
